<template>
  <div>
    <b-modal
      id="modal-skip-module"
      ref="modal-skip-module"
      centered
      title="Register Debtor in RKI"
      ok-title="Skip"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      @ok="skipHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>{{ msg }}</span>
          </div>
        </b-alert>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BAlert, BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
import { EventBus } from '@/event-bus'

export default {
  components: {
    BOverlay,
    BAlert,
  },
  props: {
    msg: {
      type: String,
      required: true,
    },
    caseId: {
      type: Number,
      required: true,
    },
    processId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    skipHandler(evt) {
      evt.preventDefault()
      this.loader = true
      axios.get(`/process/skip-debtor-registration/${this.caseId}/${this.processId}`).then(response => {
        // console.log('response ', response)
        console.log(response)
        if (response.status) {
          this.loader = false
          this.$refs['modal-skip-module'].hide()
          EventBus.$emit('refreshModules')
        }
        // window.location.reload()
      }).catch(err => {
        if (err.response.data.message) {
          this.loader = false
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
  },
}
</script>

    <style lang="scss">
    </style>
